<template>
    <popup class="pre-view-popup" fullscreen :active="active" :blocked="true">
        <template #header>
            <div class="flex head">
                <vs-button
                    type="flat"
                    icon-pack="feather"
                    icon="icon-x"
                    @click="cancelHandler()"
                ></vs-button>
                <div class="ml-2 font-semibold text-primary">
                    {{$t("my_cv_s")}}
                </div>
            </div>
        </template>
        <template #body>
            <div id="respond_popup" class="p-5 vs-con-loading__container">
                <vs-row class="mb-4">
                    <vs-col vs-lg="6" vs-sm="6">
                        <span class="main-info">{{ $t("dis_name") }}</span>
                    </vs-col>
                    <vs-col vs-lg="6" vs-sm="6">
                        <span class="main-info">{{
                            $t("last_update_date")
                        }}</span>
                    </vs-col>
                    <!-- <vs-col class="w-1/3">
                        <span class="main-info">{{ $t('act') }}</span>
                    </vs-col> -->
                </vs-row>
                <vs-row class="mb-4" v-for="(item, index) in CVs" :key="index">
                    <vs-col vs-lg="6" vs-sm="6">
                        <div class="flex items-center">
                            <vs-checkbox
                                color="rgb(115,103,240)"
                                class="mr-2"
                                @change="check(index)"
                                v-model="item.checked"
                            >
                            </vs-checkbox>
                            <span
                                class="cursor-pointer primary-color-text"
                                @click="goEdit(item)"
                                >{{ item.desired_position }}</span
                            >
                        </div>
                    </vs-col>
                    <vs-col vs-lg="6" vs-sm="6">
                        <span class="main-info">{{
                            setDateFormat(item.updated)
                        }}</span>
                    </vs-col>
                    <!-- <vs-col class="w-1/3">
                        <feather-icon
                            class="cursor-pointer delete-btn"
                            icon="XCircleIcon"
                            @click="deleteStudentCV(item.uid)"/>
                    </vs-col> -->
                </vs-row>
                <vs-button
                    class="mb-10"
                    type="border"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="goCreate()"
                >
                    {{ $t("add_cv") }}
                </vs-button>
            </div>
        </template>
        <template #footer>
            <div class="btn flex justify-end w-full p-3">
                <vs-button
                    class="vs-con-loading__container"
                    id="respond_btn"
                    type="border"
                    :disabled="!selected"
                    @click="sendRespond()"
                >
                    <span>{{ $t("send_respond") }}</span>
                </vs-button>
            </div>
        </template>
    </popup>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Popup from "./Popup.vue";
export default {
    components: { Popup },
    props: {
        active: {
            type: Boolean,
        },
        title: {
            type: String,
        },
        data: {
            type: Array,
        },
        vacancyUID: {
            type: String,
        },
    },
    data() {
        return {
            selected: false,
            selectedImage: {
                name: "",
            },
            CVs: [],
            selectedCV: {
                selected: false,
                uid: "",
            },
        };
    },
    computed: {
        ...mapGetters({
            sudentSVs: "employment/getSudentSVs",
        }),
    },
    methods: {
        ...mapActions({
            deleteStudentCV: "employment/deleteStudentCV",
            getstudentCVs: "employment/getstudentCVs",
            createRespond: "employment/createRespond",
        }),
        goCreate() {
            let uid = "";
            this.$router.push({
                params: { uid },
                name: "employment-create-cv",
            });
        },
        goEdit(item) {
            let uid = item.uid;
            this.$router.push({
                params: { uid },
                name: "employment-create-cv",
            });
        },
        cancelHandler() {
            this.$emit("close");
        },
        check(id) {
            this.CVs.forEach((el, index) => {
                if (index !== id) {
                    el.checked = false;
                } else if (el.checked) {
                    this.selected = true;
                } else {
                    this.selected = false;
                }
            });
        },
        setDateFormat(date) {
            let newDate = this.$moment(date).format("DD.MM.YYYY");
            return newDate;
        },
        async sendRespond() {
            this.$vs.loading({
                container: "#respond_btn",
                scale: 0.45,
            });
            let checked = "";
            this.CVs.forEach((el) => {
                if (el.checked === true) {
                    checked = el.uid;
                }
            });
            let obj = [
                {
                    cv: checked,
                    vacancy: this.vacancyUID,
                    is_active: true,
                },
            ];
            await this.createRespond(obj);
            this.$vs.notify({
                title: this.$t("respond_ntf"),
                text: this.$t("respond_success"),
                color: "rgb(70,201,58)",
            });
            this.$vs.loading.close("#respond_btn > .con-vs-loading");
            this.cancelHandler();
        },
        async init() {
            this.$vs.loading({
                container: "#respond_popup",
                scale: 0.45,
            });
            const data = await this.getstudentCVs();
            let arr = data.map((el) => {
                let obj = {
                    desired_position: el.desired_position,
                    updated: el.updated,
                    uid: el.uid,
                    checked: false,
                };
                return obj;
            });
            this.CVs = arr;
            this.$vs.loading.close("#respond_popup > .con-vs-loading");
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style scoped>
.delete-btn {
    color: #ea5455;
}
.vs-popup {
    width: 800px !important;
}
.primary-color-text {
    font-weight: bold;
    font-size: 600;
    color: #545da7;
}
.subtitle-text {
    font-size: large;
    font-weight: 500;
    color: #545da7;
}
.flex-between {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.main-info {
    font-weight: bold;
    font-size: 600;
}
.column-flex {
    display: flex;
    flex-direction: column;
}
.name {
    font-size: large;
    font-weight: bold;
}
.head {
    align-items: center;
    justify-content: space-between;
}
.title-text {
    font-size: large;
    font-weight: 600;
}
.wage {
    border-radius: 30px;
    background-color: #2dcd7a;
    color: white;
    font-weight: bold;
}
.close-icon {
    display: flex;
    justify-content: flex-end;
}
.imageBox {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}
.imageBox-active {
    border-radius: 5px;
    border: solid 1px #545da7;
    background-color: #f2f1f2;
}
</style>
